import { HStack } from "Components/LabIZO/Stackizo";

import PasswordChanger from "./PasswordChanger/PasswordChanger";
import EmailChanger from "./EmailChanger/EmailChanger";

import { store } from "static";

const Head = [
  {
    label: "Display Name",
    name: "UserDisplayName",
    width: 200,
  },
  {
    label: "Username",
    name: "username",
    width: 200,
  },
  {
    label: "Role",
    name: "role",
  },
  {
    label: "Email",
    name: "email",
  },
  {
    label: "Last Password Update",
    name: "LastPasswordUpdate",
    transform: "datetime",
    dateFormat: "YYYY/MM/DD HH:mm:ss",
  },
  {
    label: "Last Update",
    name: "LASTMODIFIED",
    transform: "datetime",
    dateFormat: "YYYY/MM/DD HH:mm:ss",
  },
];

const Table = [
  ...Head,
  {
    label: "Actions",
    name: "",
    width: 500,
    Cell: (row, field, addOns) => {
      if (store.user.UserID !== row._id) return <HStack />;
      return (
        <HStack gap={1}>
          <PasswordChanger docID={row._id} username={row.username} jwt={store.user.JWT} />
          <EmailChanger docID={row._id} username={row.username} jwt={store.user.JWT} />
        </HStack>
      );
    },
  },
];

const Add = [
  {
    label: "Display Name",
    name: "UserDisplayName",
    validate: ["required"],
    format: "text",
  },
  {
    label: "Username",
    name: "username",
    validate: ["required"],
    format: "text",
  },
  {
    label: "Email",
    name: "email",
    validate: ["email"],
    format: "text",
  },
  {
    label: "Password",
    name: "password",
    validate: ["required", "minimum8", "comprise"],
    format: "text",
  },
  {
    label: "Role",
    name: "role",
    format: "select",
    selectStyle: "dropdown",
    selectRef: "roleList",
    selectCap: "name",
    selectVal: "name",
    validate: ["required"],
  },
];

const Info = [
  {
    label: "Display Name",
    name: "UserDisplayName",
    format: "text",
    validate: ["required"],
  },
  {
    label: "Username",
    name: "username",
    format: "text",
    readOnly: true,
  },
  {
    label: "Email",
    name: "email",
    format: "text",
    validate: ["email"],
  },
  {
    label: "Role",
    name: "role",
    format: "text",
  },
];

const Edit = [
  {
    label: "Display Name",
    name: "UserDisplayName",
    format: "text",
    validate: ["required"],
  },
  {
    label: "Username",
    name: "username",
    format: "text",
    readOnly: true,
  },
  {
    label: "Email",
    name: "email",
    format: "text",
    validate: ["email"],
  },
  {
    label: "Role",
    name: "role",
    format: "select",
    selectStyle: "dropdown",
    selectRef: "roleList",
    selectCap: "name",
    selectVal: "name",
    validate: ["required"],
  },
];

const Export = [];

const Import = [];

const ImportFormat = [...Export];

const Filter = [];

const AdvFilter = [];

const schema = {
  Table,
  Info,
  Add,
  Edit,
  Export,
  Import,
  ImportFormat,
  Filter,
  AdvFilter,
};

export default schema;
